/**
 * Only a skill's owner or staff may change it. Ownerless skills (seeded, or
 * older than owner tracking) are staff-only. The server enforces the same rule.
 */
export function canEditSkill(
  skill: { ownerUserId?: string | null },
  userId: string | undefined,
  isStaff: boolean
): boolean {
  if (isStaff) {
    return true;
  }
  return Boolean(userId) && skill.ownerUserId === userId;
}

/** Same rule as edit. */
export const canDeleteSkill = canEditSkill;

/** A new skill is always editable; an existing one follows `canEditSkill`; the list has no form. */
export function isSkillFormReadOnly(
  mode: "list" | "create" | "edit",
  skill: { ownerUserId?: string | null } | null,
  userId: string | undefined,
  isStaff: boolean
): boolean {
  if (mode === "create") {
    return false;
  }
  return mode !== "edit" || !skill || !canEditSkill(skill, userId, isStaff);
}
